import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative inline-flex w-full max-w-lg" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "absolute left-4 inset-y-0 flex" }
const _hoisted_4 = { class: "absolute inset-x-0 top-4 pl-18 pr-4 flex overflow-hidden" }
const _hoisted_5 = { class: "text-black text-xl font-semibold leading-tight truncate" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }

import { toRefs } from 'vue';
import { debounce } from 'lodash-es';
import { Account, AccountPresenter } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    address: null,
    loading: { type: Boolean },
    account: null,
    presenter: null
  },
  emits: ['update:address'],
  setup(__props: any, { emit }) {

const props = __props as {
  address: string | null,
  loading: boolean,
  account: Account | null,
  presenter: AccountPresenter | null,
}




const {
  address, loading, account, presenter,
} = toRefs(props);

const onSearch = debounce(async (event) => {
  const newAddress: string | null = event.target.value ?? null;
  emit('update:address', newAddress);
}, 500);

return (_ctx: any,_cache: any) => {
  const _component_account_icon = _resolveComponent("account-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      class: "pl-18 pr-4 pb-3 pt-9 w-full text-gray-700 bg-blue-50/60 bg-gradient-to-br from-white/50 to-blue-100/50 shadow-lg shadow-indigo-500/30 border border-blue-50 rounded-xl backdrop-blur-lg focus:ring-pink-500 focus:border-pink-500",
      "aria-label": "Search accounts, programs, tokens, NFTs, etc.",
      placeholder: "Accounts, programs, tokens, NFTs, etc.",
      value: _unref(address),
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSearch) && _unref(onSearch)(...args))),
      onKeypress: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_unref(onSearch) && _unref(onSearch)(...args)), ["enter"]))
    }, null, 40, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_account_icon, {
            key: 0,
            state: "loading"
          }))
        : (_unref(account))
          ? (_openBlock(), _createBlock(_component_account_icon, {
              key: 1,
              presenter: _unref(presenter)
            }, null, 8, ["presenter"]))
          : (_unref(address))
            ? (_openBlock(), _createBlock(_component_account_icon, {
                key: 2,
                state: "error"
              }))
            : (_openBlock(), _createBlock(_component_account_icon, {
                key: 3,
                state: "search"
              }))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Loading..."))
          : (_unref(account))
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                textContent: _toDisplayString(_unref(presenter).name)
              }, null, 8, _hoisted_7))
            : (_unref(address))
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Account not found"))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "Search"))
      ])
    ])
  ]))
}
}

})